import React from "react";
import { useCurrency } from "../Currency/CurrencyContext";

interface PriceProps {
  amount?: number | string;
}

const Price: React.FC<PriceProps> = ({ amount = 0 }) => {
  const { currency } = useCurrency();

  // Safely convert amount to number
  const numericAmount = (() => {
    if (typeof amount === "number") {
      return amount;
    }
    if (typeof amount === "string") {
      const parsed = parseFloat(amount);
      return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  })();

  return (
    <span>
      {currency.symbol}
      {numericAmount.toFixed(2)}
    </span>
  );
};

export default Price;
